<style lang='less' scoped>
@import '../../../style/common/variable';
* {list-style-type: none;}
.center {width: 100%;display: flex;flex-direction: column;background: #fff;position: relative;justify-content:center;align-items:center;}
.photo {width: 100%;overflow: hidden;height:692px;
  img {width: 100%;overflow: auto;user-select: none;height:100%;display: block;}
  #downup {font-weight: bolder;font-size: 20px;color: #fff;position: relative;top: -20px;}
  #downup:hover {cursor: pointer;}
  .text {overflow:hidden;background: linear-gradient(to top, #1877CB 0%,#115290 100%);
    .bottom {width: 1200px;line-height: 16px;margin: 0px auto;height: 100px;
      .content {font-size: 18px;letter-spacing: 1px; overflow: hidden;color: #fff;display: inline-block;margin: 0px 36px;height: 60%;text-align: left;margin-top: 20px;line-height: 30px;}
    }
  }
}
.sub{list-style: none;width: 800px;display: flex;justify-content: space-between;margin: 20px auto; margin-top: 60px;
  .el-button{font-size: 18px;}
}
.kyzx{margin: 20px;margin-top: 40px;}
.first{display: flex;justify-content:space-between;width: 1200px;}
.country{width:1200px;margin: auto;}
.block{width: 65%;}
.real-time{width:32%; height: 505px;position: relative;overflow-y: hidden;}
.moreNews{font-size:13px;font-weight: 500;}
.moreNews:hover{color: #3c77bb;cursor: pointer;}
.dhnews {margin: 20px auto;height: 580px;display: flex;flex-direction: column;position: relative;
  p {line-height: 50px;font-size: 20px;font-weight: 600;letter-spacing: 3px;display: flex; flex-direction: column;
  /deep/.el-tabs__nav-wrap::after{display: none;}
  /deep/.el-tabs__active-bar{background: none;}
  /deep/.el-tabs__nav{margin-left: 490px;}
  /deep/.el-tabs__item{font-size: 20px;}
  i {width: 200px; height: 3px;display: inline-block;background: #3c77bb;margin: auto; }}
  .dhcard{list-style: none;margin: 0;padding: 0;width: 1200px;overflow-x: hidden;
  li{margin: 0px 10px;width: 280px;height: 420px; padding: 0px; border-radius: 0px 0px 10px 10px;box-shadow: 0px 0px 3px 1px rgb(228, 227, 227);overflow: hidden;cursor: pointer;}
  li:hover{h3{color: #3c77bb;}}
  img{width: 100%; height: 160px;}
  h3{text-align: left;margin: 10px;display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;overflow: hidden; text-overflow: ellipsis;}}
  .moreNews{font-size:13px;font-weight: 500;}
  .moreNews:hover{color: #3c77bb;cursor: pointer;}
  .dhnewscenter{position: relative;width: 1200px;overflow: hidden;
    .container3{width: 1200px;
      .dhcard {list-style: none; display: flex;width: 560000000px;}
    }
  }
}
.chcyg {width: 98%; margin: auto;margin-top: 40px;
  img { width: 100%;}
}
.zbdw{width: 1200px;}
  .cbdw{width: 1200px;
    .lgon {display: flex;justify-content: center;padding: 0;flex-wrap: wrap; margin: 0;
      li {height: 80px;line-height: 80px; margin: 20px 40px;}
      }}
  .cbdw2{width: 1200px;
    .lgon {display: flex;justify-content: center;padding: 0;flex-wrap: wrap;margin: 0;
      li {height: 120px;line-height: 120px;margin: 20px 50px;}
    }}
  .xsyz{width: 1200px;margin: 50px auto;
    img{width: 100%;height: 100%;}
  }
.zbdw {margin: auto;display: flex;flex-direction: column;
  p {line-height: 50px;font-size: 20px;font-weight: 600;letter-spacing: 3px;display: flex;flex-direction: column;
    i {width: 50px;height: 3px;display: inline-block;background: #3c77bb;margin: auto;}
  }
  .lgon {display: flex;justify-content: center;padding: 0;flex-wrap: wrap; margin: 0;
    li {height: 80px;line-height: 80px; margin: 20px 40px;}
  }
}
.cbdw {margin: auto;display: flex;flex-direction: column;
  p {line-height: 50px;font-size: 20px;font-weight: 600;letter-spacing: 3px;display: flex;flex-direction: column;
    i {width: 50px;height: 3px;display: inline-block;background: #3c77bb;margin: auto;}
  }
}
.cbdw2 {margin: auto;display: flex;flex-direction: column;
  p {line-height: 50px;font-size: 20px;font-weight: 600;letter-spacing: 3px;display: flex;flex-direction: column;
    i {width: 50px; height: 3px;display: inline-block; background: #3c77bb;margin: auto;}
  }
}
.listdata{width: 100px;font-size: 12px;border-radius: 5px;background-color: #ECF6FF;z-index: 1;margin-right: 10px}
.prevVideo{position: absolute;top: 305px;left:12px;width: 39px;height: 64px;cursor: pointer;z-index: 99;}
.nextVideo{position: absolute;top: 305px;right:12px;width: 39px;height: 64px;cursor: pointer;z-index: 99;}
.topVideo{position: absolute;top: 0px;left:160px;width: 64px;height: 39px;cursor: pointer;z-index: 99;}
.bottomVideo{position: absolute;bottom: 2px;left:160px;width: 64px;height: 39px;cursor: pointer;z-index: 99;}
.hotNews {text-align: left;margin: auto;
  ul {position: relative;list-style: none;margin-top: 0px;padding: 0px;overflow-y: hidden;height: 5050000px;
    li {border-top: 1px solid #cccccc;padding: 10px 0;height: 80px;cursor: pointer;display: flex;overflow-y: hidden;}
  }
  .picbox{width: 100px; height: 80px;overflow: hidden;}
  .pic{margin-top: -3px;}
  .box{position: absolute;left: 110px;width: 200px;}
  .titleIcon {line-height: 25px;white-space: nowrap;}
  .title {float: left;margin: -6px 8px 0px 0px;font-size: 15px;font-weight: 600;max-width: 230px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
  .icon {position: absolute;top:-2px;}
  .text {font-size: 13px; width: 270px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;color: #666666;margin: 8px 0;}
  .text{height: 28px;line-height: 14px; overflow:hidden;}
  .text::after{content: ' ... ';}
  .time{font-size: 13px;color: #000000;}
  .box:hover {color: #13569e;}
  .font1{font-size: 18px;font-weight: bold;}
}
@media screen and (max-width: @max-screen){
 .nyajb {width: 94%;margin: auto;display: flex;flex-direction: column;
  p {line-height: 50px;font-size: 20px;font-weight: 600;letter-spacing: 3px;display: flex;flex-direction: column;
    i {width: 50px;height: 3px;display: inline-block;background: #3c77bb;margin: auto;}}
  .jbname {display: flex;flex-wrap: wrap;width: 98%;padding: 0px;
    li {width: 47%;display: flex;flex-direction: column;margin-bottom: 5%;margin-left: 3%;
      h4 {padding: 0 10px;margin: 0; line-height: 30px;}
      span {color: #9f9f9f;padding: 0 5px; overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 4; -webkit-box-orient: vertical;text-align: left;line-height: 24px;font-size: 13px; }
    }
  }
}
.dhyc { width: 98%;margin: 20px auto;display: flex;flex-direction: column;
  p {line-height: 50px;font-size: 20px;font-weight: 600;letter-spacing: 3px;display: flex;flex-direction: column;
    i {width: 50px;height: 3px;display: inline-block;background: #3c77bb;margin: auto;}
  }
  /deep/.el-select{margin: auto;width: 80%;margin-bottom: 10px;}
}
.zbdw{width: 100%;}
  .cbdw{width: 100%;
    .lgon {display: flex;justify-content: center;padding: 0;flex-wrap: wrap; margin: 0;
      li {height: 80px;line-height: 80px; margin: 10px 0px;}
  }}
  .cbdw2{width: 100%;
    .lgon {display: flex;justify-content: center;padding: 0;flex-wrap: wrap;margin: 0;
      li {height: 120px;line-height: 120px;margin: 10px 0px;}
    }}
    .xsyz{width: 100%;margin: 0 auto 50px;
    img{width: 100%;height: 100%;}
  }
  .dhnews{width: 100%;
    p{
      /deep/.el-tabs__nav{display: contents;}
    }
  }
  .first{flex-direction: column; width: 100vw;
    .block{width: 100vw;}
    .real-time{width: 96vw; margin-left: 2vw;}
  }
  .hotNews .text{width: calc(91vw - 100px);}
  .hotNews .title{width: calc(81vw - 100px); max-width: none}
  .photo{display: none;}
  .sub{width: 95vw;display: flex; flex-direction: row; flex-wrap: wrap; justify-content: space-evenly; margin-left: -.3rem;}
  .button1{margin-top: .1rem;}
}

@media screen and (min-width: @max-screen){
  .nyajb {width: 1200px;margin: auto;display: flex;flex-direction: column;
    p {line-height: 50px;font-size: 20px;font-weight: 600;letter-spacing: 3px;display: flex;flex-direction: column;
      i {width: 50px;height: 3px;display: inline-block;background: #3c77bb;margin: auto;}}
    .jbname {display: flex;justify-content: space-between;padding: 0;flex-wrap: wrap;
      li {width: 13%;height: 310px;display: flex;flex-direction: column;margin: 15px 40px;
        h4 {padding: 0 10px;margin: 0; line-height: 30px;}
        span {color: #9f9f9f;padding: 0 5px; overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 4; -webkit-box-orient: vertical;text-align: left;line-height: 24px;font-size: 13px; }
      }
    }
  }
.dhyc { width: 1200px;margin: 20px auto;display: flex;flex-direction: column;
  p {line-height: 50px;font-size: 20px;font-weight: 600;letter-spacing: 3px;display: flex;flex-direction: column;
    i {width: 50px;height: 3px;display: inline-block;background: #3c77bb;margin: auto;}
  }
  /deep/.el-select{margin-left: 50px;width: 545px;margin-bottom: 10px;}}
}
</style>

<template>
  <div class="center">
    <div class="photo" id="photo">
      <img :src="img" alt="" />
    </div>
    <ul class="sub">
      <li><el-button type="primary" @click="goLtgk">矿业大会</el-button></li>
      <li><el-button type="primary" @click='toHyrc'>会议日程</el-button></li>
      <li><el-button type="primary" @click='toSignup'>参会报名</el-button></li>
      <li><el-button type="primary" class="button1" @click="downLoad()">会议邀请函</el-button></li>
    </ul>
    <p style="line-height: 50px;font-size: 20px;font-weight: 600;letter-spacing: 3px;display: flex; flex-direction: column;">
      <span>会议资讯</span>
      <i style="width: 200px; height: 3px;display: inline-block;background: #3c77bb;margin: auto;"></i>
      <span class="moreNews" @click="goNews">更多会议资讯</span>
    </p>
    <div class="first">
      <div class="block">
        <SwiperImg :widthCSH="800" :heightCSH="505" :swiperlist="Swiperlist" @clickSwiper="goDetails"></SwiperImg>
      </div>
      <div class="real-time" @mouseover="mouseOver2()" @mouseleave="mouseLeave2()">
        <img v-show="isShow2" class="topVideo" src="../../../../static/index/ic_xs.png" alt="" @click="upward" />
        <div class="hotNews">
          <ul class="content" :style="{'margin-top': margintopt + 'px'}">
            <li v-for="(item, index) in hotNewslist" :key="index"  @click="goDetails(item)">
              <div class="picbox">
                <img class="pic" :src="item.pic" style="height: 100%;" />
              </div>
              <div class="box">
                <div class="titleIcon">
                  <span class="title">{{ item.title }} </span>
                  <img class="icon" v-if="index === 0" src="static/index/toutiao.png" />
                  <img class="icon" v-if="index > 0" src="static/index/zuixin.png" />
                </div>
                <p class="text"> {{ item.text }} </p>
                <span class="time">{{item.time * 1000 | formatDate()}}</span>
              </div>
            </li>
          </ul>
        </div>
        <img v-show="isShow2" class="bottomVideo" src="../../../../static/index/ic_xx.png" alt="" @click="down" />
      </div>
    </div>
    <div class="dhnews" id="dhxw" @mouseover="mouseOver()" @mouseleave="mouseLeave()">
      <p>
        <el-tabs v-model="activeName"  @tab-click="handleClick">
          <el-tab-pane label="大会新闻" name="first"></el-tab-pane>
          <el-tab-pane label="往届回顾" name="second"></el-tab-pane>
        </el-tabs>
        <i></i>
        <span class="moreNews" @click="more">更多大会新闻</span>
      </p>
      <img class="prevVideo" src="../../../../static/index/ic_zh.png" alt="" @click="prev()" />
      <div class="dhnewscenter">
        <div class="container3" :style="{'margin-left': marginLeft + 'px'}">
          <ul class="dhcard" :style="screenWidth < 912 ? {'width': allWidth + 'px'} : ''">
            <li :style="screenWidth < 912 ? {'width': imgWidth + 'px'} : ''" v-for="(item, index) in newslist" :key="index" @click="goDetails1(item)">
              <img :src="item.dir" alt="" />
              <h3>{{ item.title }}</h3>
              <div style="margin: 10px;text-align:left;">{{ item.content }}</div>
            </li>
          </ul>
        </div>
      </div>
      <img class="nextVideo" src="../../../../static/index/ic_yh.png" alt="" @click="next()" />
    </div>
    <div class="chcyg">
      <img src="static/index/image_chgj.png" alt="" />
    </div>
    <div class="nyajb" id="yjjb">
      <p>
        <span>往届嘉宾</span>
        <i></i>
      </p>
      <ul class="jbname">
        <li v-for="(item, index) in yqjblist" :key="index">
          <img :src="item.thumb" alt="" />
          <h4>{{ item.name }}</h4>
          <span>{{ item.position }}</span>
        </li>
      </ul>
    </div>
    <div class="dhyc" id="hyrc">
      <p>
        <span>大会议程</span>
        <i></i>
      </p>
      <el-select v-model="meetingid" clearable placeholder="往届会议" @change="onchange">
        <el-option
          v-for="item in meetings"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <AgendaTabs ref="agtab" :TabsList="TabsList"></AgendaTabs>
    </div>
    <div class="zbdw">
      <p>
        <span>主办单位</span>
        <i></i>
      </p>
      <ul class="lgon">
        <li v-for="(item, index) in zbdwlist" :key="index">
          <img :src="item.thumb" alt="" style="width:320px" />
        </li>
      </ul>
    </div>
    <div class="cbdw">
      <p>
        <span>承办单位</span>
        <i></i>
      </p>
      <ul class="lgon">
        <li v-for="(item, index) in cbdwlist" :key="index">
          <img :src="item.thumb" alt="" style="width:320px; vertical-align: middle;" />
        </li>
      </ul>
    </div>
    <div class="cbdw2"  id="xbdw">
      <p>
        <span>协办单位</span>
        <i></i>
      </p>
      <ul class="lgon">
        <li v-for="(item, index) in xbdwlist" :key="index">
          <img :src="item.thumb" alt="" style="width:300px; vertical-align: middle;" />
        </li>
      </ul>
    </div>
    <div class="cbdw2"  id="xbdw">
      <p>
        <span>外方协办单位</span>
        <i></i>
      </p>
      <ul class="lgon">
        <li v-for="(item, index) in wfxbdwlist" :key="index">
          <img :src="item.thumb" alt="" style="width:300px; vertical-align: middle;" />
        </li>
      </ul>
    </div>
    <div class="xsyz">
      <router-link :to="{path: '/Exhibition'}">
        <img src="static/images/zlkindex/xsyz.png">
      </router-link>
    </div>
  </div>
</template>

<script>
/**
 * 矿业论坛首页
 */
import AgendaTabs from '../../app/assembly/AgendaTabs'
import SwiperImg from '../assembly/SwiperImg'
import HotNews from '../assembly/HotNews'
import arrayFun from '../method/array.js'
import filters from '../method/filter.js'
export default {
  components: { AgendaTabs, SwiperImg, HotNews },
  mixins: [filters],
  data()
  {
    return {
      swiperlist: [],
      hotNewslist: [],
      newslist: [], // 大会新闻
      yqjblist: [],
      activeName: 'first',
      jblist: [
        {
          dir: 'static/images/zlkindex/凌月明.png',
          name: '凌月明',
          brief: '自然资源部党组成员、副部长'
        },
        {
          dir: 'static/images/zlkindex/严值禅.png',
          name: '严值禅',
          brief: '第十九届中央候补党员,广西壮族自治区第十一届委员'
        },
        {
          dir: 'static/images/zlkindex/黄世勇.png',
          name: '黄世勇',
          brief: '广西壮族自治区副主席'
        },
        {
          dir: 'static/images/zlkindex/黄瀚.png',
          name: '黄瀚',
          brief: '广西壮族自治区人民政府副秘书长'
        },
        {
          dir: 'static/images/zlkindex/唐善茂.png',
          name: '唐善茂',
          brief: '广西壮族自治区地质矿产勘查开发局局长'
        },
        {
          dir: 'static/images/zlkindex/柯雪利.png',
          name: '柯雪利',
          brief: '广西盛隆冶金有限公司总经理'
        },
        {
          dir: 'static/images/zlkindex/吴国华.png',
          name: '吴国华',
          brief: '中国矿业联合会副会长'
        },
        {
          dir: 'static/images/zlkindex/蔡建勇.png',
          name: '蔡建勇',
          brief: '宁波力勤资源科技开发有限公司董事长'
        },
        {
          dir: 'static/images/zlkindex/赵占国.png',
          name: '赵占国',
          brief: '中国黄金集团有限公司副总经理'
        },
        {
          dir: 'static/images/zlkindex/董建雄.png',
          name: '董建雄',
          brief: '中国铝业集团有限公司副总经理'
        }
      ],
      logolist: [
        'static/company/广西壮族自治区人民政府.png',
        'static/company/中华人民共和国资源部.png'
      ],
      logolist2: [
        'static/company/广西壮族自治区国土资源厅.png',
        'static/company/中国地质调查局国际矿业研究中心.png',
        'static/company/自然资源部科技与国际合作司.png',
        'static/company/广西壮族自治区地质矿产勘查开发局.png'
      ],
      logolist3: [
        'static/company/中国自然资源经济研究院.png',
        'static/company/自然资源部国土卫星遥感应用中心.png',
        'static/company/中国地质博物馆.png',
        'static/company/中国矿业联合会.png',
        'static/company/中国黄金协会.png',
        'static/company/中国地质调查局国际矿业研究中心.png',
        'static/company/中国—东盟地学合作中心.png',
        'static/company/南方石山地区矿山地质环境修复工程技术创新中心.png',
        'static/company/自然资源广西卫星应用技术中心.png',
        'static/company/中铝广西有色稀土开发有限公司.png',
        'static/company/广西国际博览事务局.png',
        'static/company/桂林理工大学.png',
        'static/company/中国—东盟中心.png',
        'static/company/联合国教科文组织国际岩溶研究中心.png',
        'static/company/东盟国家矿业协会联合会.png'
      ],
      TabsList: [],
      TabsList1: [],
      marginLeft: 0,
      margintopt: 0,
      isShow: false,
      isShow2: false,
      meetings: [],
      meetingid: null,
      img: '',
      zbdwlist: [],
      cbdwlist: [],
      xbdwlist: [],
      wfxbdwlist: [],
      screenWidth: window.innerWidth,
      allWidth: null,
      switchWidth: null,
      imgWidth: null
    }
  },
  computed:
  {
    Swiperlist()
    {
      return this.swiperlist
    },
    HotNewslist()
    {
      return this.hotNewslist
    },
    Cardlist()
    {
      return this.cardlist
    },
    HotNewsdata()
    {
      return this.hotNewsdata
    }
  },
  mounted()
  {
    this.getKyzx()
    this.getNews()
    // this.getHyrc(23)
    this.getKyltm()
    this.getImg()
    this.getYqjb()
    this.getzbdw()
    this.getcbdw()
    this.getxbdw()
    this.getwfxbdw()
    // var that = this
    // setTimeout(function()
    // {
    //   that.$refs.agtab.getMeeting()
    // }, 1000)
  },
  watch:
  {
    $route: {
      async handler(nval, oval)
      {
        await document.querySelector('#hyrc')
        if (nval.query.kw === 'hyrc')
          document.querySelector('#xbdw').scrollIntoView({ block: 'end', behavior: 'smooth' })
      },
      immediate: true
    },
    screenWidth: {
      handler(nval, oval)
      {
        let newRest = (nval - 1) % 2
        this.switchWidth = (nval - 1 - newRest) / 2
        this.allWidth = this.switchWidth * 10
        this.imgWidth = this.switchWidth - 8
      },
      immediate: true
    }
  },
  methods: {
    onchange(meetingID)
    {
      this.getHyrc(meetingID)
    },
    // 获取矿业资讯数据
    getKyzx()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 118, _exp: 'id>0 and examine = 0 and level = 1', orderby: 'orders desc', init: 0, pageno: 1, pagesize: 20}
      window.post.getPost(paras).then((ret) =>
      {
        ret[0].data.forEach(item =>
        {
          this.swiperlist.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title})
          this.hotNewslist.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, text: item.introduce, time: item.addtime, hits: item.hits})
        })
      })
    },
    //获取大会新闻数据
    getNews()
    {
      this.marginLeft = 0
      let paras = {cmd: 'query', _major: 11, _minor: 5, _exp: 'id>0 and examine = 0 and catid != 441', orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 10}
      window.post.getPost(paras).then((ret) =>
      {
        this.newslist = []
        ret[0].data.forEach(item =>
        {
          this.newslist.push({id: item.id, dir: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, content: item.introduce})
        })
      })
    },
    //获取往届嘉宾数据
    getYqjb()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 115, _exp: 'id>0', orderby: 'orders ASC', init: 0, pageno: 1, pagesize: 20}
      window.post.getPost(paras).then((ret) =>
      {
        this.yqjblist = []
        ret[0].data.forEach(item =>
        {
          this.yqjblist.push({id: item.id, thumb: item.thumb ? item.thumb : 'static/images/moren.jpg', name: item.name, position: item.position})
        })
      })
    },
    //获取主办单位列表
    getzbdw()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 116, _exp: 'id>0 and type = 0', orderby: 'orders ASC', init: 0, pageno: 1, pagesize: 20}
      window.post.getPost(paras).then((ret) =>
      {
        this.zbdwlist = []
        ret[0].data.forEach(item =>
        {
          this.zbdwlist.push({id: item.id, thumb: item.thumb ? item.thumb : 'static/images/moren.jpg'})
        })
      })
    },
    //获取承办单位列表
    getcbdw()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 116, _exp: 'id>0 and type = 1', orderby: 'orders ASC', init: 0, pageno: 1, pagesize: 20}
      window.post.getPost(paras).then((ret) =>
      {
        this.cbdwlist = []
        ret[0].data.forEach(item =>
        {
          this.cbdwlist.push({id: item.id, thumb: item.thumb ? item.thumb : 'static/images/moren.jpg'})
        })
      })
    },
    //获取协办单位列表
    getxbdw()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 116, _exp: 'id>0 and type = 2', orderby: 'orders ASC', init: 0, pageno: 1, pagesize: 20}
      window.post.getPost(paras).then((ret) =>
      {
        this.xbdwlist = []
        ret[0].data.forEach(item =>
        {
          this.xbdwlist.push({id: item.id, thumb: item.thumb ? item.thumb : 'static/images/moren.jpg'})
        })
      })
    },
    //获取协办单位列表
    getwfxbdw()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 116, _exp: 'id>0 and type = 3', orderby: 'orders ASC', init: 0, pageno: 1, pagesize: 20}
      window.post.getPost(paras).then((ret) =>
      {
        this.wfxbdwlist = []
        ret[0].data.forEach(item =>
        {
          this.wfxbdwlist.push({id: item.id, thumb: item.thumb ? item.thumb : 'static/images/moren.jpg'})
        })
      })
    },

    //获取会议列表
    getKyltm()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 105, _exp: 'id>0', orderby: 'id DESC', init: 0, pageno: 1, pagesize: 20}
      window.post.getPost(paras).then((ret) =>
      {
        this.meetings = []
        ret[0].data.forEach(item =>
        {
          this.meetings.push(
            {
              value: item.id,
              label: item.name
            }
          )
        })
        this.meetings = this.meetings.sort((a, b) => b.value - a.value)
        this.meetingid = this.meetings[0].value
        this.getHyrc(this.meetings[0].value)
      })
    },
    //获取会议日程数据
    getHyrc(num)
    {
      let paras = {cmd: 'query', _major: 11, _minor: 34, _exp: `catid=${421} and meetingid = ${num}`, orderby: 'id ASC'}
      window.post.getPost(paras).then((ret) =>
      {
        if (ret.length !== 0)
        {
          let data = JSON.parse(JSON.stringify(ret))
          let uniqueArr = data.reduce((acc, current) =>
          {
            let found = acc.find(item => item.data === current.data)
            if (!found)
            
              acc.push(current)
            
            return acc
          }, [])
          uniqueArr.forEach(item =>
          {
            item.id = item.id.toString()
            item.content = []
          })
          uniqueArr[0].id = '0'
          for (let i = 0; i < uniqueArr.length; i++)
          {
            for (let j = 0; j < ret.length; j++)
            {
              if (ret[j].data === uniqueArr[i].data)
                uniqueArr[i].content.push({id: ret[j].id, type: ret[j].type, address: ret[j].address, arrangement: ret[j].content, glid: ret[j].glid})
            }
            uniqueArr[i].content = uniqueArr[i].content.sort(arrayFun.compareStoB('id'))
          }
          this.TabsList = uniqueArr
        }
      })
    },
    getImg()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 111, _exp: `id > 0`, orderby: 'id DESC'}
      window.post.getPost(paras).then((ret) =>
      {
        if (ret.length > 0)

          this.img = ret[0].thumb
      })
    },
    goLtgk()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 5, _exp: `catid = 28`, orderby: 'id DESC', init: 0, pageno: 1, pagesize: 1}
      window.post.getPost(paras).then((ret) =>
      {
        let url = this.$router.resolve({path: '/LtgkDetails', query: {id: ret[0].data[0].id}})
        window.open(url.href, '_blank')
      })
    },
    toSignup()
    {
      window.open('https://www.camining.cn/nav/index.html', '_blank')
    },
    //更多大会新闻
    more()
    {
      let url = this.$router.resolve({path: '/NewsList'})
      window.open(url.href, '_blank')
    },
    goNews()
    {
      let url = this.$router.resolve({path: '/NewsKyzhzx'})
      window.open(url.href, '_blank')
    },
    handleClick(val)
    {
      if (val.label === '往届回顾')
      {
        let url = this.$router.resolve({path: '/NewsList', query: {id: 181}})
        window.open(url.href, '_blank')
      }
    },
    // 跳转到大会新闻详情页面
    goDetails(item)
    {
      let url = this.$router.resolve({path: '/KyzhzxDetails', query: {id: item.id}})
      window.open(url.href, '_blank')
    },
    goDetails1(item)
    {
      let url = this.$router.resolve({path: '/DhxwDetails', query: {id: item.id}})
      window.open(url.href, '_blank')
    },
    onhandleClick(index)
    {
      this.$store.commit('onKyltID', index.id)
      let url = this.$router.resolve({path: '/DhxwDetails'})
      window.open(url.href, '_blank')
    },
    // 下载邀请函
    downLoad()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 110, _exp: 'id>0', orderby: 'id DESC', init: 0, pageno: 1, pagesize: 1}
      window.post.getPost(paras).then((ret) =>
      {
        if (ret[0].total !== 0)

          window.open(ret[0].data[0].pdf, '_blank')
        else

          this.$message.error('邀请函还未上传，请联系管理员')
      })
    },
    toHyrc()
    {
      document.querySelector('#hyrc').scrollIntoView({ block: 'start', behavior: 'smooth' })
    },
    // 向左翻
    prev()
    {
      let widthSize
      if (window.innerWidth > 912)
        widthSize = 300
      else
        widthSize = this.switchWidth
      if (this.marginLeft >= 0)
        return false
      this.marginLeft += widthSize
    },
    // 向右翻
    next()
    {
      let widthSize
      if (window.innerWidth > 912)
        widthSize = 300
      else
        widthSize = this.switchWidth
      if (this.marginLeft <= -((this.newslist.length - 2) * widthSize))
        return false
      this.marginLeft -= widthSize
    },
    // 向上翻
    upward()
    {
      if (this.margintopt >= 0)
        return false
      this.margintopt += 101
    },
    // 向下翻
    down()
    {
      if (this.margintopt <= -((this.hotNewslist.length - 5) * 101))
        return false
      this.margintopt -= 101
    },
    mouseOver()
    {
      this.isShow = true
    },
    mouseLeave()
    {
      this.isShow = false
    },
    mouseOver2()
    {
      this.isShow2 = true
    },
    mouseLeave2()
    {
      this.isShow2 = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/Promoin.vue